import { WorkTaskPartsService } from "@common/client"
import { partBalancesBaseKey } from "./part-balances"
import { partReservationsBaseKey } from "./part-reservations"
import { partStockBaseKey } from "./part-stock"
import { makeAxiosMutation, makeQuery } from "./utils"
import { workPackageKey } from "./work-packages"

const WORK_TASK_PART_PAGE_SIZE = 500

export const workTaskPartsBaseKey = ["work-task-parts"] as const

export const partWorkTaskPartsKey = (partId: string) =>
  [...workTaskPartsBaseKey, "list", partId] as const

export const partWorkTaskPartsQuery = makeQuery({
  serviceCall: (partId: string) =>
    WorkTaskPartsService.listParts({
      part_id: partId,
      limit: WORK_TASK_PART_PAGE_SIZE,
    }),
  queryKey: partWorkTaskPartsKey,
})

type InWorkOrder<P> = P & { work_package_id: string }

type RequestParams = Parameters<typeof WorkTaskPartsService.requestPart>[0]

type UpdateParams = Parameters<typeof WorkTaskPartsService.updatePart>[0]

type WithdrawParams = Parameters<typeof WorkTaskPartsService.withdrawPart>[0]

type IssueParams = Parameters<typeof WorkTaskPartsService.issuePart>[0]

export const useRequestWorkTaskPartMutation = makeAxiosMutation({
  serviceCall: ({
    work_package_id: _,
    ...params
  }: InWorkOrder<RequestParams>) => WorkTaskPartsService.requestPart(params),
  invalidates: (params) => [
    workPackageKey(params.work_package_id),
    partStockBaseKey,
    partReservationsBaseKey,
    workTaskPartsBaseKey,
  ],
})

export const useUpdateWorkTaskPartMutation = makeAxiosMutation({
  serviceCall: ({ work_package_id: _, ...params }: InWorkOrder<UpdateParams>) =>
    WorkTaskPartsService.updatePart(params),
  invalidates: (params) => [
    workPackageKey(params.work_package_id),
    partStockBaseKey,
    partReservationsBaseKey,
    workTaskPartsBaseKey,
  ],
})

export const useWithdrawWorkTaskPartMutation = makeAxiosMutation({
  serviceCall: ({
    work_package_id: _,
    ...params
  }: InWorkOrder<WithdrawParams>) => WorkTaskPartsService.withdrawPart(params),
  invalidates: (params) => [
    workPackageKey(params.work_package_id),
    partStockBaseKey,
    partReservationsBaseKey,
    workTaskPartsBaseKey,
  ],
})

export const useIssueWorkTaskPartMutation = makeAxiosMutation({
  serviceCall: ({ work_package_id: _, ...params }: InWorkOrder<IssueParams>) =>
    WorkTaskPartsService.issuePart(params),
  invalidates: (params) => [
    workPackageKey(params.work_package_id),
    partStockBaseKey,
    partReservationsBaseKey,
    workTaskPartsBaseKey,
    partBalancesBaseKey,
  ],
})
